/**
 * This view contains multiple collections of form objects corresponding to sections they are in.
 * When section form object collection is in becomes active, a corresponding collection is shown.
 */
define('formkit/view/form.object/form.object.collections.by.section.collection.view',['require','exports','module','underscore','uikit/uikit','./form.object.collection.view'],function(require, exports, module) {
  var _                        = require('underscore');
  var UIKit                    = require('uikit/uikit');
  var FormObjectCollectionView = require('./form.object.collection.view');


  var FormObjectCollectionsBySectionCollectionView = UIKit.ReordarableCollectionView.extend({
    childView: FormObjectCollectionView,

    options: {
      form: null,
      readonly: false
    },

    onChangeReadonly: function() {
      this.children.each(function(childView) {
        childView.readonly = this.readonly;
      }, this);
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      childViewOptions = _.extend({
        designable: this.getOption('designable'),
        readonly: this.getOption('readonly'),
        form: this.form
      }, childViewOptions);
      return UIKit.ReordarableCollectionView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
    }
  });
  module.exports = FormObjectCollectionsBySectionCollectionView;
});

